import { render, staticRenderFns } from "./rotateClassSearch.vue?vue&type=template&id=67c7a27e&scoped=true&"
import script from "./rotateClassSearch.vue?vue&type=script&lang=js&"
export * from "./rotateClassSearch.vue?vue&type=script&lang=js&"
import style0 from "./rotateClassSearch.vue?vue&type=style&index=0&id=67c7a27e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c7a27e",
  null
  
)

export default component.exports